import { useState } from "react";

interface ReaderImageProps {
  src: string;
  alt: string;
}

export default function ReaderImage({ src, alt }: ReaderImageProps) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const handleRetry = () => {
    setFailed(false);
    setLoaded(false);
    setReloadKey((prev) => prev + 1);
  };

  if (failed) {
    return (
      <div className="w-full aspect-[4/7] flex flex-col items-center justify-center gap-3 bg-background-100 border-y border-background-200 text-center px-4">
        <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 text-2xl">
          <i className="ri-error-warning-line"></i>
        </span>
        <p className="text-sm text-foreground-500">图片加载失败，请检查网络后重试</p>
        <button
          type="button"
          onClick={handleRetry}
          className="inline-flex items-center gap-2 h-9 px-4 rounded-md bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line"></i>
          重新加载
        </button>
      </div>
    );
  }

  return (
    <div className="relative w-full aspect-[4/7] bg-background-100">
      {!loaded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-foreground-400">
          <i className="ri-loader-4-line text-3xl animate-spin"></i>
          <span className="text-xs">漫画加载中…</span>
        </div>
      )}
      <img
        key={reloadKey}
        src={src}
        alt={alt}
        title={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setFailed(true)}
        className={`w-full h-full object-cover object-top transition-opacity duration-500 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
      />
    </div>
  );
}